import baseCssModule from './css'
import type { BeckyCssModuleResponse, BeckyModelCssModuleResponse, SiteAssetsModule } from '@wix/thunderbolt-becky-root'

const cssModule: SiteAssetsModule<BeckyCssModuleResponse | BeckyModelCssModuleResponse> = (moduleContext) => {
	return baseCssModule(moduleContext)
}

export default cssModule
